import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { Badge } from '@motorway/mw-highway-code';

import {
	displayTransportRequestedTag,
	getVehicleState,
	isCompletedPage,
} from 'Components/Account/Purchases/Purchases.helpers';
import useAccountRouter from 'Components/Account/useAccountRouter';
import type { EnquiryState } from 'Types/enquiryStates';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from '../../PurchasesVehicleList.texts';

import styles from './StatusTagGroup.module.scss';

const LocalT = new MDText(LocalTexts);

type StatusTagGroupProps = {
	className?: string;
	cypressId: string;
} & Pick<EnquiryState, 'slug' | 'transportRequested'>;

export const StatusTagGroup: FC<StatusTagGroupProps> = ({ className, cypressId, slug, transportRequested }) => {
	const { slug: URLSlug } = useAccountRouter();

	const vehicleState = getVehicleState(slug);

	if (isCompletedPage(URLSlug)) {
		return (
			<div {...applyCypressData(cypressId)} className={cx(styles.badgeGroupContainer, className)}>
				{displayTransportRequestedTag(slug, transportRequested) && (
					<Badge
						text={<span className={styles.badgeWrapper}>{LocalT.translate('badges.transport_requested')}</span>}
						variant="primary"
					/>
				)}
				{vehicleState && (
					<Badge
						text={<span className={styles.badgeWrapper}>{LocalT.translate(`badges.sold.${vehicleState}`)}</span>}
						variant="primary"
					/>
				)}
			</div>
		);
	}

	return (
		<div {...applyCypressData(cypressId)} className={cx(styles.badgeGroupContainer, className)}>
			<Badge
				text={<span className={styles.badgeWrapper}>{LocalT.translate('badges.cancelled')}</span>}
				variant="primary"
			/>
		</div>
	);
};
